import { useEffect, useState } from "react";
import { Accordion, Col, Container, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineFile } from "react-icons/ai";
import { useHistory, useParams } from "react-router-dom";
import { detailCourse } from "../../../../services/courses.service";
import { DisciplineAccordion } from "../components/discipline-accordion";
import { CardBody, CardDescription, CardTitle } from "../../styled";
import { ButtonGoBack } from "../../components/button-go-back";
import { colors } from "../../../../../theme/theme";
import { TypeCourse } from "../../../../components/translate-type-course";

export const CourseDetails = (): JSX.Element => {
	const history = useHistory();
	const { t: translation } = useTranslation();

	const { id } = useParams<{ id: string }>();
	const [loading, setLoading] = useState(true);
	const [material, setMaterial] = useState<any>();

	useEffect(() => {
		if (id) {
			detailCourse(id)
				.then((resp) => {
					setMaterial(resp);
					setLoading(false);
				})
				.catch((error: any) => {
					if (error.response && error.response.status === 404) {
						history.push("/courses");
					}
				});
		}
	}, [id]);

	if (loading) {
		return (
			<div className="loading-container mt-5">
				<Spinner animation="border" variant="primary" />
			</div>
		);
	}

	return (
		<Container fluid>
			<CardTitle color={colors.mainColors.indigo}>
				<Row>
					<Col xs={12} className="d-flex align-items-center">
						<ButtonGoBack />
						{material?.name}
					</Col>
				</Row>
			</CardTitle>

			<CardBody>
				<Row className="mt-3">
					<Col>
						<CardDescription>
							<Row>
								<Col>
									<div>
										<b>
											{translation("material.workload")}:{" "}
										</b>{" "}
										{material?.workload
											? material.workload + "h"
											: translation(
													"userAccount.uninformed"
											  )}
									</div>
								</Col>

								<Col>
									<div>
										<b>Qtd de disciplinas: </b>{" "}
										{material?.disciplines_count
											? material.disciplines_count
											: translation(
													"userAccount.uninformed"
											  )}
									</div>
								</Col>
								<Col>
									<div>
										<b>Modalidade: </b>{" "}
										{material?.type_course ? (
											<TypeCourse
												type={material.type_course}
											/>
										) : (
											translation(
												"userAccount.uninformed"
											)
										)}
									</div>
								</Col>

								{/* área de conhecimento */}
								<Col>
									<div>
										<b>Área de conhecimento: </b>{" "}
										{material?.knowledge_area?.length > 0
											? material.knowledge_area
													.map(
														(anArea: any) =>
															anArea.description
													)
													.sort((a: any, b: any) =>
														a.description <
														b.description
															? 1
															: -1
													)
													.join(", ")
											: translation(
													"userAccount.uninformed"
											  )}
									</div>
								</Col>
							</Row>
						</CardDescription>
					</Col>
				</Row>

				{material?.description && (
					<Row className="mt-3">
						<Col>
							<CardDescription>
								<div className="title mb-2">
									<AiOutlineFile
										fontSize={20}
										style={{ marginTop: "-5px" }}
									></AiOutlineFile>{" "}
									Descrição
								</div>
								<div
									dangerouslySetInnerHTML={{
										__html:
											material?.description ||
											translation(
												"userAccount.uninformed"
											),
									}}
								></div>
							</CardDescription>
						</Col>
					</Row>
				)}

				<Row className="mt-3">
					<Col xs={12}>
						<CardDescription>
							<div className="title mb-3">
								<AiOutlineFile
									fontSize={20}
									style={{ marginTop: "-5px" }}
								></AiOutlineFile>{" "}
								Disciplinas ({material?.disciplines_count})
							</div>
							<DisciplineAccordion
								disciplines={material?.disciplines}
							/>

							<Accordion className="accordion-phase view-course mt-4">
								{material?.steps &&
									material.steps.map((item: any) => (
										<Accordion.Item
											eventKey={item.id}
											data-type="collapse"
										>
											<Accordion.Header>
												<Row
													data-type="collapse"
													className="d-flex justify-content-between align-items-center w-100 p-2"
												>
													<Col
														data-type="collapse"
														style={{
															marginLeft: "35px",
														}}
													>
														<b className="name-phase">
															{item.name}
														</b>
													</Col>
												</Row>
											</Accordion.Header>
											<Accordion.Body>
												<DisciplineAccordion
													disciplines={
														item?.disciplines
													}
												/>
											</Accordion.Body>
										</Accordion.Item>
									))}
							</Accordion>
						</CardDescription>
					</Col>
				</Row>
			</CardBody>
		</Container>
	);
};
